import styled from 'styled-components';
import {
  DateField,
  TextInput,
  InputField,
  SelectField,
  TimePicker,
  TextAreaField,
  CheckBoxField,
  NumberField,
  Flex
} from '@ubeya/shared-web/components';

export const SettingsSelectField = styled(SelectField)`
  .select-input {
    height: 40px;
    max-width: 150px;
    min-height: 30px;
  }

  .select-label {
    padding: 7px 10px;
  }
`;

export const SettingsTextAreaField = styled(TextAreaField)`
  textarea {
    width: 775px;
    height: 36px;
    border-radius: 3px;
    min-width: 150px;
  }
`;

export const SettingsInputField = styled(InputField)`
  width: 120px;
`;

export const SettingsDateField = styled(DateField)`
  width: 120px;
`;

export const SettingsTextInput = styled(TextInput)`
  width: 120px;
`;

export const SettingsTimePicker = styled(TimePicker)`
  width: 120px;
`;

export const SettingsCheckBoxField = styled(CheckBoxField)`
  margin-left: -20px;
`;

export const SettingsNumberField = styled(NumberField)`
  width: 160px;
  min-height: 42px;

  button,
  input {
    min-height: 42px;
  }
`;

export const FlexWithSpacing = styled(Flex)`
  align-items: center;
  > :not(style) ~ :not(style) {
    margin-left: 16px;
  }
`;
